import Axios from 'axios'

import config from '@/config'
import stores from '@/stores'
import storage from '@/utils/storage'
import { toast } from 'react-toastify'

import ToastErrorMessage from '@/components/Elements/ToastErrorMessage'
import { logout } from '@/stores/auth/authSlice'
import { Box, Flex, Link, Text } from '@chakra-ui/react'

function authRequestInterceptor(config) {
  const token = storage.getToken()

  if (token) {
    config.headers = {
      Authorization: `Bearer ${encodeURIComponent(token)}`,
      'Access-Control-Allow-Origin': '*',
    }
  }

  // config.headers.Accept = 'application/json'
  return config
}

export const axios = Axios.create({
  baseURL: config.apiURL,
})

axios.interceptors.request.use(authRequestInterceptor)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorResponseObj = error?.response?.data
    // console.log('errorResponseObj', errorResponseObj)
    const logoutDispatch = () => stores.dispatch(logout())

    if (errorResponseObj) {
      switch (error.response.status) {
        case 404:
          break
        case 500:
        case 422:
          if (errorResponseObj?.type && errorResponseObj?.type && Array.isArray(errorResponseObj?.details)) {
            toast.error(<ToastErrorMessage details={errorResponseObj?.details} />)
          } else if (errorResponseObj?.type === 'Zod Error' && Array.isArray(errorResponseObj?.stack)) {
            toast.error(<ToastErrorMessage issues={errorResponseObj?.stack} />)
          } else if (errorResponseObj?.type === 'MISSING_SIGNATURE') {
            console.error('Error passed')
          } else if (!errorResponseObj.data) {
            // If Have data, need to handle by the useMutation itself
            toast.error(errorResponseObj?.message || 'Some error happened...')
          }
          break
        case 401:
          logoutDispatch()
          toast.info('Please login to see the requested page !')
          break
        case 413:
          toast.error('File size limit exceeded. Max. file size allowed is 20MB')
        default:
          console.error(error)
          break
      }
    }

    return Promise.reject(error)
  }
)
